import { useEffect, useState } from "react";

const normalizeSearch = (search: string) => {
  if (!search) {
    return "";
  }
  return search.startsWith("?") ? search : `?${search}`;
};

export const useLocation = () => {
  const [location, setLocation] = useState(() => ({
    pathname: window.location.pathname,
    search: window.location.search,
  }));

  useEffect(() => {
    const handlePopState = () =>
      setLocation({ pathname: window.location.pathname, search: window.location.search });
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigate = (path: string, search = window.location.search) => {
    const nextSearch = normalizeSearch(search);
    window.history.pushState({}, "", `${path}${nextSearch}`);
    setLocation({ pathname: path, search: nextSearch });
  };

  const setSearch = (
    search: string,
    options?: { replace?: boolean; path?: string },
  ) => {
    const nextSearch = normalizeSearch(search);
    const path = options?.path ?? window.location.pathname;
    const url = `${path}${nextSearch}`;
    if (`${window.location.pathname}${window.location.search}` === url) {
      return;
    }
    if (options?.replace) {
      window.history.replaceState({}, "", url);
    } else {
      window.history.pushState({}, "", url);
    }
    setLocation({ pathname: path, search: nextSearch });
  };

  return { pathname: location.pathname, search: location.search, navigate, setSearch };
};
